import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed,
  ref,
  watch,
  onMounted,
  nextTick,
} from 'vue'
import { useI18n } from 'vue-i18n'
import SelectPayee from '@/components/SelectPayee.vue'
import FormRulesFactory from '@/common/formRules'
import InputWithUnitNumber from '@/components/InputWithUnitNumber.vue'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'StrategyPayeeConfig',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isEdit: {
    type: Boolean,
  },
  operatorID: {
    type: String,
    default: '0',
  },
  list: {
    type: Array,
    required: false,
    default: () => [],
  },
},
  emits: ['update:list'],
  setup(__props, { expose, emit }) {

const props = __props

const { t } = useI18n()
const { tl } = useI18nTl('formRules')



const formRule = ref({
  ...FormRulesFactory.generateCustomRules(['payeeId'], 'inputEmpty', 'inputInvalid', {
    pattern: /^\d+(\.\d{1,2})?$/,
    maxDecimalPlaces: 2,
  }),
  ...FormRulesFactory.generateCustomRules(['percentage'], 'inputEmpty', 'inputInvalid', {
    pattern: /^\d+?$/,
    min: 1,
    max: 100,
  }),
})

// 初始化规则
// console.log('🚀 ~ formRule:', formRule.value)
const topicForm = ref()
expose({
  validate: async () => {
    await nextTick()
    if (topicForm.value) {
      return topicForm.value.validate()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
  resetFields: async () => {
    await nextTick()
    if (topicForm.value) {
      topicForm.value.resetFields()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
  clearValidate: async () => {
    await nextTick()
    if (topicForm.value) {
      topicForm.value.clearValidate()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
})
const disabled = ref(props.isEdit)
const feeModel = ref<Record<string, any>>({})
const feeList = computed({
  get: () => props.list,
  set: (val: any) => {
    emit('update:list', val)
  },
})

const addItem = () => {
  let tmp = {
    payeeId: null,
    percentage: 0,
  }
  console.log('🚀 ~ addItem:', tmp)
  feeList.value.push(tmp)
}

const disableAdd = (row: any) => {
  return feeList.value.length >= 8
}

const delItem = (row: any) => {
  feeList.value.forEach((v, k) => {
    if (v === row) {
      feeList.value.splice(k, 1)
    }
  })
}

watch(
  () => props.isEdit,
  (val) => {
    disabled.value = val
  },
  { immediate: true }, // 立即执行，确保初始加载时也同步
)

watch(
  () => props.list,
  (newList) => {
    if (props.isEdit) {
      feeList.value = [...newList]
      feeModel.value.feeList = [...newList]
      feeModel.value.feeList.forEach((v: any) => {
        v.percentage = String(v.percentage)
      })
    }
  },
  { immediate: true, deep: true }, // 立即执行，确保初始加载时也同步
)

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "topicForm",
    ref: topicForm,
    model: feeModel.value,
    "validate-on-rule-change": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: _unref(feeList),
        class: "shadow-none",
        "row-style": { height: '56px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _unref(t)('Operation.payee')
          }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.payeeId`,
                rules: formRule.value.payeeId,
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(SelectPayee, {
                    modelValue: row.payeeId,
                    "onUpdate:modelValue": ($event: any) => ((row.payeeId) = $event),
                    disabled: props.operatorID == '0' || !props.operatorID
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('Operation.profitSharingPercentage')
          }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.percentage`,
                rules: formRule.value.percentage,
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(InputWithUnitNumber, {
                    modelValue: row.percentage,
                    "onUpdate:modelValue": ($event: any) => ((row.percentage) = $event),
                    units: [{ label: '%', value: '' }]
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('Base.remark')
          }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.remark`,
                rules: formRule.value.remark
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    min: 0,
                    modelValue: row.remark,
                    "onUpdate:modelValue": ($event: any) => ((row.remark) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, { width: "80" }, {
            header: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addItem())),
                disabled: disableAdd(scope) || !_ctx.$hasPermission('post')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.add')), 1)
                ]),
                _: 2
              }, 1032, ["disabled"])
            ]),
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                disabled: !_ctx.$hasPermission('delete'),
                onClick: ($event: any) => (delItem(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})